import { Button } from "../components/ui/button";
import { useLocation, useNavigate } from "react-router-dom";
import AddBookForm from "./AddBookForm";
import AddCharacterForm from "./AddCharacterForm";
import { useState } from "react";

const Menu = ({ openAddCharacterForm, openAddBookForm, setSetupMode }: { openAddCharacterForm?: () => void, openAddBookForm?: () => void, setSetupMode?: () => void }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [showForm, setShowForm] = useState(false);

    const currentPath = location.pathname;

    // Define menu items based on current path
    const menuItems = [];

    if (currentPath !== "/dashboard") {
        menuItems.push({ label: "Return to Dashboard", path: "/dashboard" });
    }

    if (currentPath !== "/booklist") {
        menuItems.push({ label: "Book List", path: "/booklist" });
    }

    if (currentPath !== "/characterlist") {
        menuItems.push({ label: "Character List", path: "/characterlist" });
    }

    return (
        <div className="relative group">
            <Button className="bg-[#333333] text-white px-4 py-2 rounded">
                Menu
            </Button>

            <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-300 rounded-md shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all duration-200 z-50">
                <ul className="py-1 text-sm text-gray-800">
                    {menuItems.map((item) => (
                        <li key={item.path}>
                            <button
                                onClick={() => navigate(item.path)}
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                            >
                                {item.label}
                            </button>
                        </li>
                    ))}

                    {currentPath === "/booklist" && openAddBookForm && (
                        <li>
                            <button
                                onClick={openAddBookForm}
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                            >
                                Add Book
                            </button>
                        </li>
                    )}

                    {currentPath === "/characterlist" && openAddCharacterForm && (
                        <li>
                            <button
                                onClick={openAddCharacterForm}
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                            >
                                Add Character
                            </button>
                        </li>
                    )}

                    {currentPath === "/dashboard" && setSetupMode && (
                        <li>
                            <button
                                onClick={setSetupMode}
                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                            >
                                Enter Setup Mode
                            </button>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default Menu;
